
import React from 'react';
import { useRole, Role } from '../hooks/useRole.ts';
import { Crown, HardHat, Calculator, Check, ShieldAlert } from 'lucide-react';

export const RoleSelector: React.FC = () => {
    const { role, changeRole } = useRole();

    const roles: { id: Role; label: string; icon: React.ReactNode; desc: string }[] = [
        {
            id: 'OWNER',
            label: 'Owner',
            icon: <Crown size={18} className="text-amber-500" />,
            desc: 'Full access. Financials, AI Insights, Settings.'
        },
        {
            id: 'FOREMAN',
            label: 'Foreman',
            icon: <HardHat size={18} className="text-orange-500" />,
            desc: 'Field focus. Daily Logs, Photos, Schedule.'
        },
        {
            id: 'ACCOUNTANT',
            label: 'Accountant',
            icon: <Calculator size={18} className="text-emerald-500" />,
            desc: 'Back-office. Invoices, Budget, Reports.'
        }
    ];

    return (
        <section className="bg-white p-10 rounded-[3rem] border border-zinc-200 shadow-sm animate-in fade-in space-y-8">
            <div className="flex items-center gap-4">
                <div className="p-3 bg-zinc-900 rounded-2xl text-white shadow-xl">
                    <ShieldAlert size={24} />
                </div>
                <div>
                    <h3 className="text-2xl font-black text-black tracking-tight uppercase">Operational Role</h3>
                    <p className="text-[10px] font-black text-zinc-400 uppercase tracking-widest mt-1">Profit Safeguard Protocol</p>
                </div>
            </div>

            <div className="grid grid-cols-1 gap-4">
                {roles.map((r) => (
                    <button
                        key={r.id}
                        onClick={() => changeRole(r.id)}
                        className={`flex items-center gap-6 p-6 rounded-[2rem] border text-left transition-all group ${role === r.id
                                ? 'border-black bg-zinc-50 ring-2 ring-black shadow-lg scale-[1.01]'
                                : 'border-zinc-100 bg-white hover:bg-zinc-50'
                            }`}
                    >
                        <div className={`p-4 rounded-2xl border transition-all ${role === r.id ? 'bg-black border-black' : 'bg-zinc-50 border-zinc-100'
                            }`}>
                            {r.icon}
                        </div>
                        <div className="flex-1">
                            <div className="flex justify-between items-center mb-1">
                                <h4 className="font-black text-sm text-black uppercase tracking-wide">{r.label}</h4>
                                <Check size={16} className={role === r.id ? 'text-black' : 'text-transparent'} />
                            </div>
                            <p className="text-[10px] text-zinc-500 font-bold leading-relaxed">{r.desc}</p>
                        </div>
                    </button>
                ))}
            </div>
        </section>
    );
};
